import { useContext, useMemo } from 'react';
import { ace_hooks, assignment_hooks } from '@axo/shared/data-access/hooks';
import { DataAccessContext } from '@axo/shared/data-access/provider';
import { useShouldUseAssignmentsVersion } from './useShouldUseAssignmentsVersion';

export function useAssignedApplicationIds(marketCountry: string) {
  const user = useContext(DataAccessContext).state.user;
  const version = useShouldUseAssignmentsVersion({ marketCountry });
  const isV3 = version === 'v3';

  const agentAssignmentsList = ace_hooks.useGetAgentAssignmentsListV3(
    user.clientID,
    { enabled: isV3 }
  );

  const assignedApplications = assignment_hooks.useAssignedApplications(
    marketCountry,
    { enabled: !isV3 }
  );

  return useMemo(() => {
    if (isV3) {
      return agentAssignmentsList.data?.map((a) => a.LoanApplicationID) ?? [];
    }
    return (
      assignedApplications.data?.Items?.map((a) => a.LoanApplicationID) ?? []
    );
  }, [isV3, agentAssignmentsList.data, assignedApplications.data?.Items]);
}
